import React from 'react';
import PropTypes from 'prop-types';
import TextHighlighter from 'dyzio-shared-components/lib/components/text-highlighter';
import _ from 'lodash';
import { Divider, Card, Grid, Icon, Table, List, Image } from 'semantic-ui-react';
import DyzioInstagramEmbed from '../../components/dyzio-instagram-embed';

import { DyzioSecondaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';

import { transformHashtagstIntoArray } from '../../utils/hashtags-utils';
import { commaFormatted } from '../../utils/helpers/formatting';
import { getTrackedAssetAnalytics } from '../../utils/tracked-assets-analytics-service';

import Comments from './comments';
import ExistingAds from './existing-ads';

const getCaption = asset => {
  if (_.has(asset, 'attributes.initialData.standardFormat.text')) {
    const caption = _.get(asset, 'attributes.initialData.standardFormat.text');
    return caption;
  }
  return 'No caption';
};

const avatarStyle = {
  width: 50,
  height: 50,
  float: 'left',
  margin: '10px',
  backgroundColor: 'gray',
  display: 'inline-block',
};

const handleStyle = {
  padding: '15px 5px 5px 5px',
  marginLeft: 5,
  float: 'left',
  display: 'inline-block',
  fontSize: 16,
};

const captionBoxStyle = {
  whiteSpace: 'pre-wrap',
};

const textCentered = {
  textAlign: 'center',
};

const shareButtonStyle = {
  border: '0px solid #1d1937',
};

const noPadding = {
  padding: '0',
};

class InstagramPost extends React.Component {
  constructor() {
    super();
    this.state = {
      privateData: null,
      isLoadingPrivateData: true,
    };
  }

  async componentDidMount() {
    const { asset } = this.props;
    const trackedAssetId = asset.id;
    console.log(`ta => ${trackedAssetId}`);
    const attributes = _.get(asset, 'attributes');
    const analyticsPayload = {
      id: _.get(asset, 'id'),
      type: _.get(asset, 'type'),
      ...attributes,
    };
    const response = await getTrackedAssetAnalytics([analyticsPayload]);
    const record = _.head(response);
    const privateData = _.get(record, 'response.data', {});
    this.setState({
      isLoadingPrivateData: false,
      privateData,
      trackedAssetId,
    });
  }

  render() {
    const { asset, campaign, influencer, ads, unlinkAd } = this.props;
    const { privateData, trackedAssetId } = this.state;
    const assetURL = _.get(asset, 'attributes.assetURL');
    const assetId = _.get(asset, 'attributes.assetId');
    const caption = getCaption(asset);
    const hashtags = transformHashtagstIntoArray(_.get(campaign, 'attributes.hashtags'), '');
    const { instagramThumbnail, instagram, instagramCount } = _.get(influencer, 'attributes');

    const reach = 1.1 * (_.get(privateData, 'latestInsights.reach') ||
     _.get(privateData, 'latestStatistic.playCount') ||
      _.get(privateData, 'latestStatistic.viewCount'));

    const impressions = 1.3 * (_.get(privateData, 'latestInsights.impressions') ||
      _.get(privateData, 'latestStatistic.playCount') ||
       _.get(privateData, 'latestStatistic.viewCount'));

    const engagements = _.get(privateData, 'latestInsights.engagement') ||
    _.get(privateData, 'latestStatistic.likeCount', 0) + _.get(privateData, 'latestStatistic.commentCount', 0);

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width="9">
              <Card fluid>
                <Card.Content>
                  <DyzioSecondaryButton
                    label="open asset in new tab"
                    icon={<Icon name="share" />}
                    style={shareButtonStyle}
                    hasIcon
                    onClick={() => window.open(assetURL, '_blank')}
                    fluid
                  />
                </Card.Content>
              </Card>
              <Card fluid>
                <Card.Content>
                  <Grid>
                    <Grid.Row>
                      <Image
                        src={instagramThumbnail}
                        className="circular"
                        size="tiny"
                        style={avatarStyle}
                      />
                      <div style={handleStyle}>
                        <b>
                          {
                            _.truncate(instagram, {
                              length: 15,
                            })
                          }
                        </b>
                        <Divider hidden fitted />
                        { commaFormatted(instagramCount) } followers
                      </div>
                    </Grid.Row>
                  </Grid>
                </Card.Content>
                <Card.Content style={noPadding}>
                  <DyzioInstagramEmbed maxWidth assetId={assetId} />
                </Card.Content>
              </Card>
              <Card fluid>
                <Card.Content>
                  <ExistingAds ads={ads} unlinkAd={unlinkAd} />
                </Card.Content>
              </Card>
            </Grid.Column>
            <Grid.Column width="7">
              <Card fluid>
                <Card.Content>
                  <Card.Header>Instagram Metrics</Card.Header>
                </Card.Content>
                <Card.Content>
                  <Table basic="very">
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>reach</Table.Cell>
                        <Table.Cell>{commaFormatted(reach) }</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>impressions</Table.Cell>
                        <Table.Cell>{commaFormatted(impressions) }</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>engagement</Table.Cell>
                        <Table.Cell>{commaFormatted(engagements) }</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>saved</Table.Cell>
                        <Table.Cell>{commaFormatted(_.get(privateData, 'latestInsights.saved', _.get(privateData, 'latestStatistic.saved', 0))) }</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Content>
              </Card>
              <Card fluid>
                <Card.Content>
                  <Card.Header>Caption</Card.Header>
                  <Card.Meta>highlighted text shows hashtag matches</Card.Meta>
                </Card.Content>
                <Card.Content>
                  <TextHighlighter style={captionBoxStyle} text={caption !== 'No caption' ? caption : _.get(privateData, 'text', caption)} words={hashtags} />
                </Card.Content>
              </Card>
              <Card fluid>
                <Card.Content>
                  <Card.Header>Comments</Card.Header>
                  <Card.Meta>click star to favourite the comment</Card.Meta>
                </Card.Content>
                <Card.Content>
                  {
                    privateData && <Comments {...privateData} influencer={influencer} trackedAssetId={trackedAssetId} />
                  }
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

InstagramPost.propTypes = {
  asset: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  influencer: PropTypes.object.isRequired,
};

export default InstagramPost;



/** WEBPACK FOOTER **
 ** ./src/containers/view-asset-page/instagram-post.js
 **/